/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GoToFrontDesk/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import * as fromFlow from 'Simple/Flow'
import GoToFrontDesk01 from 'DesignSystem/Svgs/GoToFrontDesk01/index'
import React from 'react'
import Timeout from 'DesignSystem/Timeout/react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function GoToFrontDesk({
  children,
  viewPath = "/App/Account/GoToFrontDesk"
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<button
  data-testid="GoToFrontDesk.Vertical"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Start'))}
 {...isHoveredBind}
 style={{'--o-1-Z1dLMIw': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="GoToFrontDesk.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="GoToFrontDesk.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
We are sorry
</span>
<span
  data-testid="GoToFrontDesk.Text:1"
  data-view-path={viewPath}
 className={`views-text ${styles.Text1}`}
>
You are not checked-in
</span>
<span
  data-testid="GoToFrontDesk.Text:2"
  data-view-path={viewPath}
 className={`views-text ${styles.Text2}`}
>
Please see the front desk for assistance
</span>
<GoToFrontDesk01
  viewPath={`${viewPath}/GoToFrontDesk01`}
 height={300}
 width={400}
/>
<Timeout
  viewPath={`${viewPath}/Timeout`}
 onTimeout={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Start'))}
 delay={20000}
/>
</div>
</button>
{children}
</React.Fragment>)
}